import { Button, Text, Colors } from 'basic-ui-lib';
import { Modal } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
type Props = {};
type Configs = {
  message?: string;
};
type Ref = {
  open: (callback: () => void, configs?: Configs) => void;
};
export type ModalConfirmRef = Ref;
export const globalModalConfirmRef = React.createRef<Ref>();
export const alertConfirm: Ref['open'] = (cb, type) => globalModalConfirmRef.current?.open(cb, type);
export const useModalConfirmRef = () => useRef<Ref>(null);
const ModalConfirm = forwardRef<Ref, Props>(({}, ref) => {
  const [configs, setConfigs] = useState<Configs | null>(null);
  const callbackRef = useRef<() => void>(() => undefined);
  const [open, setOpen] = useState<boolean>(false);
  const onClose = () => setOpen(false);
  const onOpen: Ref['open'] = async (cb, _configs) => {
    setConfigs(_configs || null);
    callbackRef.current = cb;
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  const handleDone = () => {
    onClose();
    callbackRef.current();
  };
  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal title={null} open={!!open} onClose={onClose} width={540} destroyOnClose closable={false} footer={null} styles={{ content: { padding: 0 } }}>
      <ContentContainer>
        <IcWarning />
        {configs?.message && (
          <Text content_2 medium center>
            {configs?.message}
          </Text>
        )}
      </ContentContainer>
      <FooterActions>
        <Button lg style={{ flex: 1 }} onClick={handleCancel} type_cancel>
          No
        </Button>
        <Button lg style={{ flex: 1 }} onClick={handleDone} type_red>
          Delete
        </Button>
      </FooterActions>
    </Modal>
  );
});

ModalConfirm.displayName = 'ModalConfirm';

export default ModalConfirm;

const ContentContainer = styled.div`
  display: flex;
  padding: 24px 80px 32px 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 5px;
`;
const FooterActions = styled.div`
  display: flex;
  padding: 16px 16px 24px 16px;
  align-items: flex-end;
  gap: 16px;
  align-self: stretch;
  border-radius: 0 0 16px 16px;
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
`;

const IcWarning = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100' fill='none'>
    <path
      d='M48.3653 11.4922C52.0391 10.7129 56.0079 12.5156 57.9356 15.7149C68.545 34.2617 79.1661 52.8027 89.7832 71.3457C90.5098 72.6582 91.3829 73.918 91.7774 75.3867C92.4727 77.6797 92.2813 80.2305 91.1778 82.3652C89.7129 85.3359 86.5567 87.4395 83.2188 87.4453C61.2735 87.4492 39.3262 87.4453 17.3809 87.4492C14.8848 87.4551 12.3536 86.5078 10.586 84.7246C8.90044 83.043 7.91412 80.6934 7.86724 78.3164C7.80669 76.4336 8.36919 74.5762 9.25787 72.9317C20.1563 53.9434 31.0391 34.9473 41.8926 15.9356C42.3282 15.0371 43.0938 14.377 43.8282 13.7305C45.1114 12.6055 46.6954 11.834 48.3653 11.4922ZM49.0586 16.252C47.8887 16.6016 46.7247 17.25 45.9922 18.2481C35.3497 36.8399 24.7149 55.4395 14.0723 74.0332C13.5059 75.0332 12.8418 76.0137 12.6309 77.166C12.2012 78.8731 12.8477 80.7969 14.254 81.8652C15.4512 82.8359 17.0762 82.9414 18.5567 82.918C40.043 82.916 61.5293 82.916 83.0157 82.918C84.5918 82.9336 86.0704 81.9434 86.8301 80.5899C87.6954 79.1094 87.627 77.1934 86.8145 75.707C75.7754 56.4082 64.6993 37.127 53.6758 17.8223C52.5762 16.5137 50.7422 15.7832 49.0586 16.252Z'
      fill='#FF6900'
    />
    <path
      d='M45.8321 35.0567C47.6427 32.8672 51.2071 32.5371 53.4552 34.2324C54.6017 35.041 55.4064 36.3125 55.6681 37.6895C55.9278 38.9258 55.7716 40.1992 55.6056 41.4375C54.922 45.7832 53.7345 50.0254 52.8282 54.3242C52.3009 56.8711 52.0431 59.459 51.8575 62.0488C50.6681 62.0801 49.4806 62.1328 48.2911 62.1074C48.0255 54.5977 45.1739 47.4824 44.4747 40.0274C44.3146 38.2891 44.6622 36.4082 45.8321 35.0567Z'
      fill='#FF6900'
    />
    <path
      d='M49.1172 63.8066C52.123 63.1055 55.2402 65.5293 55.5976 68.5313C56.0898 71.3164 54.0996 74.2227 51.3535 74.8359C48.3984 75.6309 45.0625 73.5156 44.5078 70.5098C43.7891 67.4922 46.0996 64.2832 49.1172 63.8066Z'
      fill='#FF6900'
    />
  </svg>
);
